import React from 'react';
import { VendorCTAType } from '../../redux/vendorCTAsReducer';

export interface DarwinCtaSelectorProps {
  ctaDetails: VendorCTAType;
}

const DarwinCta = ({ ctaDetails }: DarwinCtaSelectorProps) => {
  return (
    <>
      {/* eslint-disable-next-line */}
      <div className="vendorIntegrations__darwin">
        {/* eslint-disable-next-line */}
        <div></div>
      </div>
    </>
  );
};

export default DarwinCta;
